const NAME_MIN_LENGTH = 3;
const NAME_MAX_LENGTH = 200;

// Unicode-letter words separated by a single space (supports Latin, Arabic, etc.).
const PERSON_NAME_REGEX = /^(?:\p{L}+(?: \p{L}+)*)$/u;

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const PHONE_REGEX = /^(\+\d{1,2}\s?)?\d{8,}$/;

const PASSWORD_REGEX =
  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;

export function isValidPersonName(value: string): boolean {
  const trimmed = value?.trim() ?? "";
  if (trimmed.length < NAME_MIN_LENGTH || trimmed.length > NAME_MAX_LENGTH) {
    return false;
  }
  return PERSON_NAME_REGEX.test(trimmed);
}

export function isValidEmail(value: string): boolean {
  return EMAIL_REGEX.test(value?.trim() ?? "");
}

export function isValidPhone(value: string): boolean {
  return PHONE_REGEX.test(value ?? "");
}

export function isStrongPassword(value: string): boolean {
  return PASSWORD_REGEX.test(value ?? "");
}

export function hasMinLength(value: string, min: number): boolean {
  return (value?.trim()?.length ?? 0) >= min;
}
